import AntLayout from 'antd/es/layout';
import type { ComponentProps } from 'react';
import { cx } from 'src/view/shared/styles/cx';
import styles from './LayoutWrapper.module.css';

const LayoutWrapper = ({
  className,
  ...rest
}: ComponentProps<typeof AntLayout>) => (
  <AntLayout className={cx(styles.layoutWrapper, className)} {...rest} />
);

export default LayoutWrapper;
